const setCertificationSuccess = (store, { token, expiration }) => {
  store.commit('certificationSuccess', {
    token,
    expiration
  })
}

const setCertificationFailure = store => {
  store.commit('certificationFailure')
}

export default {
  setCertificationSuccess,
  setCertificationFailure
}
